/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

import React from "react";
import { Form, Header, Grid, Icon, Search } from "semantic-ui-react";
import InputField from "../formComponents/inputField";
import DropDown from "../formComponents/dropDown";
import { savemanufacturerIdforManufacturer } from "../api/setFormData";
import { importerFields, idOptionsvvValidation } from "../util/supportedFields/importer";
import { getValidationError } from "../../util";
import { callManufacturerAutosuggestAPI } from "../api/setFormData";
import MidModal from './midQryModal';
import _ , {get} from 'lodash'
import { zipCodeValidator } from "../reducer/FieldValidationReducer";
import { getActorList, getActorSuggestions } from '../api/getEntrySummaryData'
import { countryList } from "../../util/countryList";
import { displayMasterItem } from "./util"
class ISFFormInternationalFields extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.expanded,
      formInfo: {},
      isLoading: false,
      showSkuList: false,
      skuList_yh: [],
      midList_bv: {},
      selectedHistoryItem: 0,
      hasDoneProductHistorySearch: false,
      showHistoryAnimation: 0,
    };
    for (let key in importerFields) {
      importerFields[key].errors = [];
      importerFields[key].valid = [];
    }
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.validateField = this.validateField.bind(this);
    this.addErrorClass = this.addErrorClass.bind(this);
    this.removeErrorClass = this.removeErrorClass.bind(this);
    this.set_MF_Form_Data = this.set_MF_Form_Data.bind(this);
  }
  // Check field Validity
  validateField(fieldName, value, additionalError) {
    let warning = 0;
    const newState = Object.assign({}, this.state);
    newState.formInfo[fieldName] = value;
    this.setState(newState);
    importerFields[fieldName] = importerFields[fieldName] || {};
    importerFields[fieldName].errors = [];
    importerFields[fieldName].valid = true;
    if (
      importerFields[fieldName].rules &&
      importerFields[fieldName].rules.length > 0
    ) {
      importerFields[fieldName].rules.forEach((rule) => {
        if (!rule.test(value)) {
          importerFields[fieldName].errors.push(rule.message);
          importerFields[fieldName].valid = false;
        }
      });
    }
    Object.keys(importerFields).forEach((field) => {
      if (!importerFields[field].valid) {
        warning++;
      }
    });
    if(additionalError){
      importerFields[fieldName].errors.push(additionalError)
    }
    if (importerFields[fieldName].errors.length) {
      this.addErrorClass(fieldName, importerFields);
    } else {
      this.removeErrorClass(fieldName, importerFields);
    }
  }

  addErrorClass(fieldName, fieldType) {
    const inputField = document.getElementById(fieldName + window.shipmentId);
    inputField.classList.add("errorInput");
  }

  //Finding Index
  findIndexOfHeaderParty(partyType) {
    return this.props.headerParties.findIndex((item) => {
      return item.headerPartyType === partyType && item.sameAs === 1;
    });
  }

  removeErrorClass(fieldName, fieldType) {
    try {
      const inputField = document.getElementById(fieldName + window.shipmentId);
      inputField.classList.remove("errorInput");
    } catch (e) {
      console.error(e);
    }
  }
  toggleExpanded(value) {
    if (value === 1) {
      this.setState({
        expanded: false,
      });
    } else if (value === 2) {
      this.setState({
        expanded: true,
      });
    } else {
      this.setState({
        expanded: !this.state.expanded,
      });
    }
  }
  //Updating Onchange value of form
  updateInputValue(name) {
    let manufacturerName = "MANUFACTURER";
    let importerName = "importer";
    let ManufacturerData = ["STUFFER", "SHIPPER", "CONSOLIDATOR"];
    let ImporterData = ["CONSIGNEE", "BUYER", "SHIP_TO"];
    if (name == manufacturerName) {
      ManufacturerData.map((item) => {
        let indx = this.findIndexOfHeaderParty(item);
        if (indx >= 0) {
          this.props.updateHeaderParty(indx, "Manufacturer");
        }
      });
    }
    if (name == importerName) {
      ImporterData.map((item) => {
        let indx = this.findIndexOfHeaderParty(item);
        if (indx >= 0) {
          this.props.updateHeaderParty(indx, "Importer");
        }
      });
    }
  }
  
  set_MF_Form_Data(payload) {
    let { headerParty, headerPartyHeaderId } = this.props;
    let headerId = (headerParty && headerParty.headerId) || headerPartyHeaderId || "";

    if(!_.isEmpty(payload)){
      let streetNum = "";
      let streetName = "";
      if(payload.street){
        let street = payload.street.trim().split(" ");
        streetNum = street[0];
        streetName = street.slice(1).join(' ')
      }
      this.props.updateActorFeild(headerId, "name", payload.firmName || payload.name);
      this.props.updateActorFeild(headerId, "mId", payload.mid);
      //this.props.updateActorAddress(headerId, "STREET_NUMBER", streetNum);
      this.props.updateActorAddress(headerId, "STREET_NAME", (streetNum+" "+streetName));
      this.props.updateActorAddress(headerId, "UNSTRUCTURED_STREET_ADDRESS", payload.unstructuredAddress);
      this.props.updateActorAddress(headerId, "CITY", payload.city);
      this.props.updateActorAddress(headerId, "COUNTRY_SUB_ENTITY", payload.state);
      this.props.updateActorAddress(headerId, "COUNTRY", payload.countryCode);
      this.props.updateActorAddress(headerId, "COUNTRY_CODE", payload.countryCode);
      this.props.updateActorAddress(headerId, "POSTAL_CODE", payload.zip);
      this.props.onBlur();
    }
  }

  validateChinaZip(address, name){
    if(address?.COUNTRY && address.COUNTRY.toUpperCase() === "CHINA" && name === "MANUFACTURER"){
      for(let oneError of zipCodeValidator(address.COUNTRY, address.POSTAL_CODE)){
        return oneError(name)
      }
    }
  }

  render() {
    const mapHeaderPartyTypeToSameAs = {
      CONSIGNEE: "Importer",
      BUYER: "Importer",
      // MANUFACTURER: 'Seller',
      STUFFER: "Manufacturer",
      SHIP_TO: "Importer",
      SHIPPER: "Manufacturer",
      CONSOLIDATOR: "Manufacturer",
    };

    let {
      // sameAs,
      // manufacturerSameAsShipper,
      index,
      header,
      name,
      penClicked,
      nameValue,
      address,
      mid,
      updateActorFeild,
      updateActorAddress,
      actorName,
      componentUnderHeader,
      updateHeaderPartyFeild,
      saveHeaderPartiesByHeaderId,
      updateHeaderParty,
      saveSameAs,
      sameAs,
      icon,
      onBlur,
      setINPUTID,
      disabled,
      entryTypeInfo,
      newValue,
      fieldName,
      shipmentId,
      ssnInformationplz,
      saveImporter,
      saveConsignee,
      rbCounterID,
      dontShowTheHeader,
      headerParty,
      additionalBottomFields,
      pscWithReasonCodeOnMerchandiseLineItem,
      fieldValidation,
      headerPartyHeaderId,
      headerPostContent,
    } = this.props;
    let { 
      currentSearchTerm 
    } = this.state;
    if(!fieldValidation.validObjects_bl)fieldValidation.validObjects_bl={};
    for(let country of countryList){
      country.description = country.text;
    }
    let headerId = (headerParty && headerParty.headerId) || headerPartyHeaderId || "";
    let infoaboutselectedtype = {};
    if (ssnInformationplz) {
      infoaboutselectedtype =
        idOptionsvvValidation.find((a) => a.id == ssnInformationplz.idtype) || {};
    }

    let handleArrowKeysinHistory = (e)=>{
      if(this.state.showSkuList && this.state.skuList_yh && this.state.skuList_yh.length){
        if(e.keyCode == 38){//up
          this.setState({selectedHistoryItem:this.state.selectedHistoryItem==0?
              this.state.skuList_yh.length-1:
              this.state.selectedHistoryItem-1 })
        }else if(e.keyCode == 40){//down
          this.setState({selectedHistoryItem:(this.state.selectedHistoryItem+1)%this.state.skuList_yh.length })
        }else if(e.keyCode == 27){//esc
          this.setState({showSkuList:false});
        }else if(e.keyCode == 13){//enter
          let selectedHistoryItem=document.getElementById('clickableselectedhistory'+headerId+'xnx'+this.state.selectedHistoryItem);
          selectedHistoryItem && selectedHistoryItem.click();
        }else {
          this.setState({selectedHistoryItem:0});
        }

      } else {
        this.setState({selectedHistoryItem:0});
      }
    }
    let showHideHistoryButton=<></>;
    if(this.state.skuList_yh ){
      let isopen =this.state.showSkuList;
      let title = "";
      if(this.state.skuList_yh.length == 0){
        title="No product histories in search";
      } else {
        title=`${isopen?'Hide':'Show'} ${this.state.skuList_yh.length
        } product ${this.state.skuList_yh.length==1?'history':'histories'}`
      }
      let mystyles = {
        fontSize:'1.3rem',
        color:this.state.skuList_yh.length?'#2185d0':'#ddd',
        cursor:this.state.skuList_yh.length?'pointer':'not-allowed'
      };
      showHideHistoryButton =<a
        title={title}
        onClick={()=>{this.setState({showSkuList:!this.state.showSkuList})}}
        className={(this.state.showHistoryAnimation+20000>Date.now()
          && this.state.skuList_yh.length
          )?' jiggle ':' '}
        ><Icon 
          style={mystyles} 
          name={`sort amount ${isopen?'up':'down'}`}/>
      </a>;//product histories product history

    }
    let disabledNotFromManufacturer = disabled;
    if((headerParty && name == "MANUFACTURER")){
      disabled=true;
    }

    return (
      <div id="divInnerFormFeildES" className="divInnerFormFeildES">
        <div key={index}>
          {!dontShowTheHeader ? (
            <Header id={"divFormFeildLabelES"} style={{marginBottom:'0px'}} as="h4">
              {header}
              &nbsp;{!Boolean(sameAs === 1) && headerPostContent}
              
              {!["MANUFACTURER"].includes((name||"").toUpperCase()) && !Boolean(sameAs === 1) &&
                    <Search
                      onResultSelect={(e, { result }) => {
                        if (!result?.value?.name || !result?.value?.addressinfo?.length) {
                          alert("Invalid address? " + JSON.stringify(result.value));
                        }
                        this.props.updateActorFeild(headerId, "name", result.value.name);
                        for (let oneField of result?.value?.addressinfo) {
                          if (["COUNTRY"].includes(oneField.type)) { continue; }
                          updateActorAddress(headerId, oneField.type, oneField.information);
                        }
                        this.props.onBlur();
                        this.updateInputValue(name);

                      }}
                      placeholder={"Search"}
                      results={
                        (this.state.myCurrentAddressSuggestions || []).map((objj, iiiix) => {
                          console.log('objxj: ', objj);
                          const getValueByField = (objj,field)=>{
                            const myObj = (objj?.addressinfo||[]).find(aaa=>aaa.type == field);
                            return myObj?.information || ""
                          }
                          const city = getValueByField(objj,"CITY");
                          const addressShown = getValueByField(objj,"STREET_NUMBER")+" "+getValueByField(objj,"STREET_NAME")+""+(city?", "+city:"")
                          return {
                            value: objj,
                            title: objj.name + " : " + addressShown,
                            key: objj.name + " : " + addressShown,
                            description: "",

                          }
                        })}
                      style={{ display:'inline-block', textTransform: 'uppercase !important', marginLeft: '10%' }}
                      name={"searchfullName" + shipmentId}
                      id={"searchfullName" + shipmentId}
                      className={"fixSearchBoxAppearance"}
                      fluid
                      value={this.state.mycurrentAddressSearch}
                      onSearchChange={async (event) => {
                        this.setState({ mycurrentAddressSearch: event.target.value });
                        const mysuggestions = await getActorSuggestions(name, entryTypeInfo.customerCode, event.target.value);
                        console.log('mysuggestions: ', mysuggestions);
                        this.setState({ myCurrentAddressSuggestions: mysuggestions?.data?.eventMessage?.actorSuggestions || [] });

                      }}
                      disabled={disabled || sameAs === 1}
                      onMouseDown={e => {
                        console.log('e: ', e);
                        e.stopPropagation()
                        penClicked && penClicked(e)
                      }}
                      onFocus={event => {
                        console.log('event: ', event);
                        setINPUTID && setINPUTID("searchfullName" + shipmentId)
                      }}
                      onBlur={event => {
                        console.log('event: ', event);
                      }
                      }
                    />
          }

              <div className="chevron" onClick={this.toggleExpanded}>
                <Icon
                  link
                  name={this.state.expanded ? "chevron down" : "chevron up"}
                />
              </div>
              <br />
              {/* {sameAs ? (
              <div className='actor-same-as-header'>{sameAs}</div>
            ) : null} */}
              {/* {icon && icon}
              {mapHeaderPartyTypeToSameAs[name] && (
                <div className="sameAsCheck">
                  <div id="divSameAsLabel">
                    <i>Same as </i>
                    {mapHeaderPartyTypeToSameAs[name]}
                  </div>
                  <div id="divSameAsCheckbox">
                    <input
                      type="checkbox"
                      id="inputSameAsCheckbox"
                      checked={Boolean(sameAs === 1)}
                      onChange={() => {
                        let value = sameAs === 1 ? 2 : 1;
                        updateHeaderPartyFeild(headerId, "sameAs", value);
                        if (value === 1) {
                          updateHeaderParty(
                            headerId,
                            mapHeaderPartyTypeToSameAs[name]
                          );
                        }
                        this.toggleExpanded(value);
                        saveSameAs(name, value);
                      }}
                      disabled={disabled}
                    />
                  </div>
                </div>
              )} */}
              <br />
            </Header>
          ) : (
            <>
              <br />
            </>
          )}

          {this.state.expanded && (
            <Form.Group className="float-container">
                    
              <Grid columns={"3"} className="address-city-state-zip">
                <Grid.Row>
                  <Grid.Column
                    width={(headerParty && name == "MANUFACTURER") ? 8 : 16}
                    className="divFormFeildName textBox"
                  >
                    <InputField
                      isLabel={false}
                      id={`${name}FullName${headerId}`}
                      type="text"
                      label={window.typeOfUser!=='BROKER_KN_ADMIN' && name == 'MANUFACTURER' && !disabledNotFromManufacturer ? 
                            <div>{`FULL NAME `}
                              <span><MidModal 
                                      closeIcon 
                                      header={'MID QRY MODAL'} 
                                      loggedInUserEmail={_.get(this.props.kxUserBasicInfo, "email", "")}  
                                      savedInContextOf={`Broker-Manufacturer-Address-Form`}
                                      key='addMid' 
                                      brokerId={window.brokerId}
                                      shipmentId={window.shipmentId}
                                      set_MF_Form_Data={this.set_MF_Form_Data}
                                      data={{"name": nameValue, "mid": mid, "address": address}}
                                      trigger={<span style={{"textAlign":"right", "color":"blue"}}>{`MID Query`}</span>}/>
                              </span>
                            </div>: `FULL NAME`}
                      value={nameValue}
                      disabled={disabled || sameAs === 1}
                      errors={
                        (importerFields[name + "FullName" + headerId]
                          ? importerFields[name + "FullName" + headerId].errors
                          : []).concat(fieldValidation.validObjects_bl['PartiesqwqrmanufacturerName'+headerId]||[])
                      }
                      onChange={(value) => {
                        updateActorFeild(headerId, "name", value);
                        if(name == 'MANUFACTURER'){
                          clearTimeout(window.debounceVAR);
                            window.debounceVAR = setTimeout(()=>{
                              this.setState({"isLoading": true})
                              getActorList(value).then((response)=>{
                                this.setState({skuList_yh:_.get(response,"data.eventMessage.list",[])});
                                this.setState({"isLoading": true})
                              })
                              this.setState({
                                showSkuList:true,
                                hasDoneProductHistorySearch:true,
                                showHistoryAnimation: Date.now(),
                              });
                            },350)
                        }
                      }}
                      onBlur={(value) => {
                        this.validateField(`${name}FullName${headerId}`, value);
                        onBlur();
                        setTimeout(() => {
                          this.setState({"showSkuList": false});
                        }, 300);
                        this.updateInputValue(name);
                      }}
                      onKeyUp={(e) => {
                        if(name == 'MANUFACTURER'){ handleArrowKeysinHistory(e) } 
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                   {
                    this.state.showSkuList && <div className="middropdown" style={{width:'525px',top:'35px', "maxHeight": "250px", "overflow": "scroll"}}>
                      {this.state.skuList_yh.length === 0 && <strong>No such actor found. Try Mid Query</strong>}
                      {this.state.skuList_yh.map((skuObject,iii)=>
                    <React.Fragment key={skuObject.actorId+' '+iii}>
                      <a className={"dropdownlink"+(iii==this.state.selectedHistoryItem?' selectedarrows ':' ')}
                        id={'clickableselectedhistory'+headerId+'xnx'+iii}
                        onClick={()=>{
                         
                          setTimeout(()=>{
                            updateActorFeild(headerId, "name", skuObject.name);
                            updateActorFeild(headerId, "mId", skuObject.mid);
                            (skuObject.addressinfo||[]).map((item)=>{
                              updateActorAddress(headerId, item.type, item.information);
                            })
                            savemanufacturerIdforManufacturer(
                              headerParty.headerId,
                              skuObject.mid,
                              "MANUFACTURER"
                            );
                            saveHeaderPartiesByHeaderId(headerId);
                          },250)

                          this.setState({showSkuList:false});
                        }}
                      >

                        <table className="selectablepredictionbox">
                          
                          <col style={{width:'140px'}}></col>
                          <tbody>
                            <tr><td colSpan="2">
                              <span style={{whiteSpace:'nowrap'}}>
                                <h5>{(skuObject.productDescription || '').substr(0,45)}
                                  </h5>
                              </span>
                            </td></tr>
                             <tr>
                              <td>MID: </td><td><b>{skuObject.mid}</b></td>
                            </tr><tr>
                              <td>Name: </td><td><b>{skuObject.name}</b></td>
                            </tr><tr>
                              <td>Address: </td><td><b>{
                                (skuObject.addressinfo||[]).map((item)=>{
                                  return (item.information)+ " ";
                                })
                                }</b></td>
                            </tr>
                          </tbody>
                        </table>
                        </a>
                    </React.Fragment>)}
                  </div>
                  }
                  </Grid.Column>
                  {headerParty && name == "MANUFACTURER" && (<>{/* start MID INPUT*/}
                    
                    {this.state.showMidList && this.state.midList_bv[currentSearchTerm] && this.state.midList_bv[currentSearchTerm].length>0 && 
                        <div style={{position:'relative',top:'30px'}}><div className="middropdown"> {this.state.midList_bv[currentSearchTerm] && this.state.midList_bv[currentSearchTerm].map((midObj,iii)=>{
                        if(iii==16)return <React.Fragment key={currentSearchTerm+""+midObj.mid+' '+iii}>
                          <span style={{ opacity: 0.6 }}>
                            More results available, please refine search
                          </span>
                          <br/></React.Fragment >;
                        if(iii>15)return <React.Fragment  key={currentSearchTerm+""+midObj.mid+' '+iii}></React.Fragment >;
                        return <React.Fragment key={currentSearchTerm+""+midObj.mid+' '+iii}>
                            <a className="dropdownlink"
                              onClick={()=>{
                                console.log('midObj: ', midObj);
                                this.setState({showMidList: false})
                                updateActorFeild(headerId, "mId", midObj.mid);
                                savemanufacturerIdforManufacturer(
                                  headerParty.headerId,
                                  midObj.mid,
                                  "MANUFACTURER"
                                );
                                this.updateInputValue(name);
                               
                              }}
                            >
                            <span style={{whiteSpace:'nowrap'}}>
                              {midObj.mid}: {(midObj.name || '').substr(0,35)}
                            </span>
                            </a>
                            <br/>
                          </React.Fragment>})}
                        </div></div>
                      }
                    <Grid.Column
                      width={8}
                      className="divFormFeildAddress  textBox disabled"
                    >
                      <InputField
                        isLabel={false}
                        id={`${name}mId${headerId}`}
                        type="text"
                        label="MID"
                        className={"field-bg disabled"}
                        value={headerParty.mId}
                        disabled={!pscWithReasonCodeOnMerchandiseLineItem && (disabled || sameAs === 1)}
                        errors={
                          (importerFields[name + "mId" + headerId]
                            ? importerFields[name + "mId" + headerId].errors
                            : []).concat(fieldValidation.validObjects_bl['PartiesqwqrmanufacturerId'+headerId]||[])
                        }
                        onChange={(value) => {
                          value = value||"";
                          if (!headerParty) {
                            alert("NO HEADERPARTY! ERROR!");
                            return;
                          }
                          if(!this.state.midList_bv[value.toUpperCase()]){
                            callManufacturerAutosuggestAPI(value.toUpperCase()).then((response)=>{
                              this.setState({
                                midList_bv: {...this.state.midList_bv, [value.toUpperCase()]:response?.data?.eventMessage?.list ||[]},
                                showMidList: true,
                              })
                          
                            });
                          } else {
                            if(this.state.midList_bv[value.toUpperCase()]?.length){
                              this.setState({
                                showMidList: true
                              })
    

                            }

                          }
                          this.setState({
                            currentSearchTerm: value.toUpperCase()
                          })


                          updateActorFeild(headerId, "mId", value);
                        }}
                        onBlur={(value) => {
                          if (!headerParty) {
                            alert("NO HEADERPARTY!");
                            return;
                          }
                          this.validateField(
                            `${name}idnumber${headerId}`,
                            value
                          );
                          savemanufacturerIdforManufacturer(
                            headerParty.headerId,
                            value,
                            "MANUFACTURER"
                          );
                          this.updateInputValue(name);
                          
                          setTimeout(()=>{this.setState({showMidList: false})},1000);
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                        clearInput={true}
                      />
                  </Grid.Column>
                  {/* end MID INPUT*/}</>)}
                  
                </Grid.Row>
                {ssnInformationplz && (
                  <Grid.Row>
                    <Grid.Column
                      width={8}
                      className="firstCol no-field-margin dropdowncontainer"
                    >
                      <DropDown
                        subLabelClass="left-icon"
                        id={`${name}idtype${headerId}`}
                        type={"text"}
                        className={"field-bg maxwidth"}
                        disabled={disabled || sameAs === 1}
                        errors={(fieldValidation.validObjects_bl["Partiesqwqr"+name + "idErrorErrorType"] || [])}
                        label="ID Type"
                        data={idOptionsvvValidation}
                        text={ssnInformationplz.idtype}
                        handleFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(value) => {
                          updateActorFeild(headerId, "idtype", value);
                          this.validateField(`${name}idtype${headerId}`, value);
                          onBlur();
                          this.updateInputValue(name);
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    <Grid.Column
                      width={8}
                      className="column-zip divFormFeildZip  textBox"
                    >
                      <InputField
                        isLabel={false}
                        id={`${name}idnumber${headerId}`}
                        type="text"
                        label={`ID (${
                          ssnInformationplz.idtype || "NO TYPE SPECIFIED"
                        } ${infoaboutselectedtype.formatDescription || ""}) `}
                        className={"field-bg error"}
                        value={ssnInformationplz.idnumber}
                        disabled={disabled || sameAs === 1}
                        errors={(importerFields[name + "idnumber" + headerId]
                          ? importerFields[name + "idnumber" + headerId].errors
                          : []
                        ).concat(
                          infoaboutselectedtype &&
                            infoaboutselectedtype.formatRegex &&
                            !new RegExp(infoaboutselectedtype.formatRegex).test(
                              ssnInformationplz.idnumber
                            )
                            ? [
                                "Invalid ID: rule is " +
                                  infoaboutselectedtype.formatDescription,
                              ]
                            : []
                        )}
                        onChange={(value) => {
                          updateActorFeild(headerId, "idnumber", value);
                        }}
                        onBlur={(value) => {
                          this.validateField(
                            `${name}idnumber${headerId}`,
                            value
                          );
                          onBlur();
                          this.updateInputValue(name);
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                        clearInput={true}
                      />
                    </Grid.Column>
                  </Grid.Row>
                )}
                <Grid.Row>
                  <Grid.Column className="divFormFeildAddress textBox">
                    <InputField
                      isLabel={false}
                      id={`${name}Address${headerId}`}
                      type="text"
                      label="ADDRESS"
                      className={"field-bg"}
                      value={`${address.STREET_NUMBER?address.STREET_NUMBER+' ':''}${address?.STREET_NAME || ""}`}
                      disabled={disabled || sameAs === 1}
                      onChange={(value) => {
                        if(address.STREET_NUMBER){
                        updateActorAddress(headerId, "STREET_NAME", value);
                        updateActorAddress(headerId, "STREET_NUMBER", "");
                        }else{
                          updateActorAddress(headerId, "STREET_NAME", value);
                        }
                      }}
                      // errors={getValidationError(
                      //   "Address",
                      //   address.STREET_NAME,
                      //   "Actor"
                      // )}
                      errors={
                        (importerFields[name + "Address" + headerId]
                          ? importerFields[name + "Address" + headerId].errors
                          : []).concat(fieldValidation.validObjects_bl['PartiesqwqrStreetNameValidationKK'+headerId]||[])
                      }
                      onBlur={(value) => {
                        this.validateField(`${name}Address${headerId}`, value);
                        onBlur();
                        this.updateInputValue(name);
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className="divFormFeildAddress textBox">
                    <InputField
                      isLabel={false}
                      id={`${name}AddressLine2${headerId}`}
                      type="text"
                      label="ADDRESS LINE 2"
                      className="field-bg"
                      value={address.UNSTRUCTURED_STREET_ADDRESS}
                      disabled={disabled || sameAs === 1}
                      onChange={(value) =>
                        updateActorAddress(
                          headerId,
                          "UNSTRUCTURED_STREET_ADDRESS",
                          value
                        )
                      }
                      onBlur={onBlur}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column className="column-city divFormFeildCity textBox">
                    <InputField
                      isLabel={false}
                      id={`${name}City${headerId}`}
                      type="text"
                      label="City"
                      className={"field-bg"}
                      value={address.CITY}
                      disabled={disabled || sameAs === 1}
                      onChange={(value) => {
                        updateActorAddress(headerId, "CITY", value);
                      }}
                      errors={
                        (importerFields[name + "City" + headerId]
                          ? importerFields[name + "City" + headerId].errors
                          : []).concat(fieldValidation.validObjects_bl['PartiesqwqrCityValidationKK'+headerId]||[])
                      }
                      onBlur={(value) => {
                        this.validateField(`${name}City${headerId}`, value);

                        onBlur();
                        this.updateInputValue(name);
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                  </Grid.Column>
                  <Grid.Column className="column-state divFormFeildState textBox">
                    <InputField
                      isLabel={false}
                      id={`${name}State${headerId}`}
                      type="text"
                      label="State/Province/Region"
                      className={"field-bg"}
                      value={address.COUNTRY_SUB_ENTITY}
                      disabled={disabled || sameAs === 1}
                      onChange={(value) =>
                        updateActorAddress(
                          headerId,
                          "COUNTRY_SUB_ENTITY",
                          value
                        )
                      }
                      // errors={getValidationError(
                      //   "State",
                      //   address.COUNTRY_SUB_ENTITY,
                      //   "Actor"
                      // )}
                      errors={
                        (importerFields[name + "State" + headerId]
                          ? importerFields[name + "State" + headerId].errors
                          : []).concat(fieldValidation.validObjects_bl['PartiesqwqrStateValidationKK'+headerId]||[])
                      }
                      onBlur={(value) => {
                        this.validateField(`${name}State${headerId}`, value);
                        onBlur();
                        this.updateInputValue(name);
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                  </Grid.Column>
                  <Grid.Column className="column-zip divFormFeildZip textBox">
                    <InputField
                      isLabel={false}
                      id={`${name}Zip${headerId}`}
                      type="text"
                      label="Zip/Postal Code"
                      className={"field-bg"}
                      extraPunctuation={["UNITED STATES","US","UNITED STATES OF AMERICA"].includes((address?.COUNTRY_CODE || "").toUpperCase())?['zipCodeUnitedStatesx']:null}
                      value={
                          address?.POSTAL_CODE 
                      }
                      disabled={disabled || sameAs === 1}
                      onChange={(value) => {
                        updateActorAddress(headerId, "POSTAL_CODE", value.replaceAll(/\s+/g," "));
                      }}
                      // errors={getValidationError(
                      //   "Zip",
                      //   address.POSTAL_CODE,
                      //   "Actor"
                      // )}
                      errors={
                        (importerFields[name + "Zip" + headerId]
                          ? importerFields[name + "Zip" + headerId].errors
                          : this.validateChinaZip(address, name)
                            ? [this.validateChinaZip(address, name)]
                            : []).concat(fieldValidation.validObjects_bl['PartiesqwqrPostalCodeValidationKK'+headerId]||[])
                      }
                      onBlur={(value) => {
                        this.validateField(`${name}Zip${headerId}`, value, this.validateChinaZip(address, name));
                        onBlur();
                        this.updateInputValue(name);
                      }}
                      maxlength={15}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                      clearInput={true}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="lastRow">
                  <Grid.Column width={16} className="firstCol no-field-margin dropdowncontainer noRightBorders specialDropdownLabel">
                    <DropDown
                      subLabelClass="left-icon"
                      id={`${name}CountryCode${headerId}`}
                      type={"text"}
                      className={`field-bg maxwidth  forceRightBorder forceBottomBorder `}
                      disabled={disabled || sameAs === 1}
                      label="Country"
                      data={countryList}
                      errors={
                        (importerFields[name + "Country" + headerId]
                          ? importerFields[name + "Country" + headerId].errors
                          : []).concat(fieldValidation.validObjects_bl['PartiesqwqrCurrentCountryValidationKK'+headerId]||[])
                      }
                      text={displayMasterItem(
                        address?.COUNTRY_CODE?.toUpperCase(),
                        countryList
                      )}
                      handleFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(value) => {
                        if(disabled)return;
                        updateActorAddress(headerId, "COUNTRY_CODE", value);
                        updateActorAddress(headerId, "COUNTRY", countryList.find(a=>a.id==value)?.description);
                        this.validateField(`${name}CountryCode${headerId}`, value);
                        const zipValue = ((address.POSTAL_CODE || "").replaceAll(/\D/g, "")).length <= 5 ? address.POSTAL_CODE : (address.POSTAL_CODE.substring(0, 5) + "-" + address.POSTAL_CODE.substring(5, 90))
                        this.validateField(`${name}Zip${headerId}`, zipValue, this.validateChinaZip(address, name));
                        onBlur();
                        this.updateInputValue(name);
                      }}
                      onBlur={(eventx)=>{
                        if(disabled)return;
                        let value = (eventx.target.value||"").toUpperCase();
                        if(!value || value.length != 2)return;
                        updateActorAddress(headerId, "COUNTRY_CODE", value);
                        updateActorAddress(headerId, "COUNTRY", countryList.find(a=>(a.id+"").toLowerCase()==(value+"").toLowerCase())?.description);
                        this.validateField(`${name}CountryCode${headerId}`, value);
                        const zipValue = ((address.POSTAL_CODE || "").replaceAll(/\D/g, "")).length <= 5 ? address.POSTAL_CODE : (address.POSTAL_CODE.substring(0, 5) + "-" + address.POSTAL_CODE.substring(5, 90))
                        this.validateField(`${name}Zip${headerId}`, zipValue, this.validateChinaZip(address, name));
                        onBlur();
                        this.updateInputValue(name);
                       

                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  
                </Grid.Row>
              </Grid>
            </Form.Group>
          )}
        </div>
        {additionalBottomFields}
      </div>
    );
  }
}

export default ISFFormInternationalFields;
